export default __webpack_public_path__ + "static/media/og-toys-sold-out.cb87e640.svg";